import { render, staticRenderFns } from "./gift-animation.vue?vue&type=template&id=d3da0ea4&scoped=true&"
import script from "./gift-animation.vue?vue&type=script&lang=js&"
export * from "./gift-animation.vue?vue&type=script&lang=js&"
import style0 from "./gift-animation.vue?vue&type=style&index=0&id=d3da0ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3da0ea4",
  null
  
)

export default component.exports